// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4029f1a2","453":"aecef830","455":"c6f42526","977":"3df99244"}[chunkId] + ".chunk.js";
};